/**
 * About component
 *
 * Space for you to describe more about yourself.
 */

import React from "react";

/**
 * About background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that 
 * represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a image you
 * freely use on your site.
 */
import image from "../images/motion-background.jpg";

const imageAltText = "Purple and Blue Abstract Background";

/**
 * Sort description that expands on your title on the Home component.
 */
const description =
"I'm an IT student at RGPV University, Bhopal, passionate about intuitive UI design. With expertise in ReactJS, JavaScript, and MongoDB, I aim to create innovative solutions blending creativity and simplicity for optimal user experiences.";

/**
 * List of some of skills or technologies you work on, are learning,
 * passionate about, or enjoy,
 */
const skillsList = [
  "Full-Stack Development",
  "Front-End Developmemnt",
  "Back-End Development",
  "Object Oriented Programming [OOP]",
  "Software Development Life Cycle [SDLC]",
  "Responsive Web Design",
  "Problem Solving",
  "Version Control (Git/GitHub)",
];

/**
 * Use this to give more information about what you are passionate about,
 * how you best work, or even a quote. This will help someone learn more
 * about you on a professional level.
 */
const detailOrQuote =
  "I am passionate about solving problems in new, creative ways to drive innovation. With a keen eye for detail and a dedication to user-centric design, I continually seek to make technology more accessible and intuitive for all.";

const About = () => {
  return (
    <section className="section-about">
      <img className="background" src={image} alt={imageAltText} />
      <div id="about">
        <h2 className="about-head">About Myself</h2>
        <p className="large">{description}</p>
        <hr />
        <ul className="about-list">
          {skillsList.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
        <hr />
        <p className="about-below-quote">
          {detailOrQuote}
        </p>
      </div>
    </section>
  );
};

export default About;
